"use client";

import HeroSection from "@/components/common/HeroSection";
import MiniCard from "@/components/common/MiniCard";
import ImageCard from "@/components/common/ImageCard";
import Process from "@/components/common/Process";
import LastSection from "@/components/uiux/LastSection";
import SectionHeader from "@/components/common/SectionHeader";

import { CardData, ProcessData, ImageCardData } from "@/constants/UIUXData";

export default function UIUX() {
  return (
    <div className="relative flex flex-col justify-center items-center mt-6 mx-5 md:mx-[40px] xl:mx-[100px] 3xl:mx-[150] z-10">
      <section>
        <HeroSection
          heading="UI/UX Design"
          subHeading="Crafting Seamless Digital Experiences"
          paragraph="At ICIEOS, we don’t just design screens - we design moments, emotions, and digital journeys that stick. Our UI/UX team turns ideas into user-first interfaces that not only look good but feel natural."
          headingStyles="text-[60px] mobile:text-[75px] sm:text-[90px] md:text-[115px] tablet:text-[135px] lg:text-[155px] xl:text-[165px] laptop:text-[175px] 3xl:text-[190px] 4xl:text-[220px] leading-[100%] text-center opacity-100"
        />
      </section>

      <SectionHeader
        title={"what we do best"}
        wrapperClassName="xl:mt-[133px] xl:mb-0 px-0"
      />
      <div className="hidden tablet:grid grid-cols-3 w-full max-w-[2000px] gap-3 md:gap-5 xl:gap-[100px] xl:mt-[50px] auto-rows-fr">
        {CardData.map((item, index) => (
          <MiniCard
            key={index}
            icon={item.icon}
            heading={item.heading}
            paragraph={item.paragraph}
            paragraphStyles="leading-[28px] tracking-[0.02em] h-full xl:pr-10"
          />
        ))}
      </div>
      {/* a flex layout for minicards in small screens cause when there's 2 rows the card in 2nd row wanted to centered*/}
      <div className="flex tablet:hidden flex-row flex-wrap justify-around w-full gap-3 sm:gap-5 mt-[50px] ">
        {CardData.map((item, index) => (
          <MiniCard
            key={index}
            icon={item.icon}
            heading={item.heading}
            paragraph={item.paragraph}
            paragraphStyles="leading-[28px] tracking-[0.02em] h-full"
            cardStyles="
            w-full
            mobile2:w-[264px]
            sm:w-[290px]
            md:w-[334px]
            "
          />
        ))}
      </div>

      <section>
        <Process
          Data={ProcessData}
          sectionHeight={1080}
          sectionStyles="xl:mt-[105px]"
        />
      </section>

      {/* <SectionHeader
        title={"latest projects"}
        description="A collection of my latest design works focused on enhancing user experiences and crafting modern digital interfaces."
        wrapperClassName="mt-[50px] mb-0 md:mb-0 xl:mb-0"
      /> */}

      {/* Card slider for small screens */}
      {/* <div className="flex w-full mobile:hidden gap-4 overflow-x-auto snap-x snap-mandatory no-scrollbar">
        {ImageCardData.map((item, index) => (
          <div
            key={index}
            className="flex-shrink-0 basis-[80%] small:basis-[65%]"
          >
            <ImageCard
              image={item.image}
              topic={item.topic}
              text={item.text}
              sizes="(max-width: 480px) 80vw, 65vw"
            />
          </div>
        ))}
      </div> */}

      {/* <div className="hidden mobile:grid grid-cols-2 tablet:grid-cols-3 w-full max-w-[2000px] gap-x-6 2xl:gap-x-8 3xl:gap-x-10 4xl:gap-x-12 gap-y-2 mt-[30px] xl:mt-[70px] mx-auto">
        {ImageCardData.map((item, index) => (
          <ImageCard
            key={index}
            image={item.image}
            topic={item.topic}
            text={item.text}
            sizes="(max-width: 768px) 50vw, 33vw"
          />
        ))}
      </div> */}

      <section className="flex w-full justify-center">
        <LastSection />
      </section>

      <section>
        <SectionHeader
          title={"READY TO CREATE SOMETHING MEANINGFUL?"}
          description={
            "Whether you’re building from scratch or reimagining what already exists, we’re here to help you make it beautiful, usable, and unforgettable."
          }
          wrapperClassName="xl:mt-25 mb-[50px] px-0"
          descriptionClassName="xl:mt-[50px]"
        />
      </section>
    </div>
  );
}
